import { createFileRoute } from '@tanstack/react-router';
import { type AggregateBreadcrumb, buildBreadcrumb } from '@interxfi/app-components/components/router-breadcrumbs/router-breadcrumbs';
import { SWEEPS_JOB_BASE_PATH } from '../../../../../../../../../features/sweeps/clearing/job/sweeps-job-routing';

export const Route = createFileRoute('/_app/_clearing-core/_clearing-required/clearing/operations/_operations/sweep/job/_job')({
  loader: () =>
    ({
      breadcrumb: buildBreadcrumb({
        id: 'sweep-jobs-list',
        label: 'Sweeps',
        to: SWEEPS_JOB_BASE_PATH,
      }),
    }) satisfies AggregateBreadcrumb,
});
